<template>
  <div>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ 'Master Tur' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteMasterTur()"> {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formmasterpaket" v-model="validmasterpaket" lazy-validation>
                      <v-layout wrap>

                        <v-flex xs12 sm12 md12>
                          <div v-show="codegorunum === true ">
                            <v-text-field label="Tur Kodu" :color="color" v-model="MasterTur.TurKodu" > </v-text-field>
                             
                              
                           
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Tur Adı" :color="color" v-model="MasterTur.TurAdi"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            label="Kategori"
                            v-model="MasterTur.KategoriId"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select></v-flex>
                          <v-flex xs12 sm12 md12>
                          <v-select
                            label="Ürün Grubu"
                            v-model="MasterTur.UrunGrubuId"
                            item-text="UrunGrubuAdi"
                            item-value="Id"
                            items="urunGruplari"
                            
                          ></v-select></v-flex>
                          <v-flex xs12 sm12 md4>
                            <v-text-field label="Gündüz" :color="color" v-model="MasterTur.Gunduz"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field label="Gece" :color="color" v-model="MasterTur.Gece"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Notlar" :color="color" v-model="MasterTur.Notlar">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <div v-show="codegorunum === true ">
                            <v-text-field label="Kontenjan" :color="color" v-model="MasterTur.Kontenjan" > </v-text-field>
                             
                              
                           
                          </div>
                        </v-flex>

                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>

            <div v-show="m === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletemastertur()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>
            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>


            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{'Master Turlar'}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yeniekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{'Master Tur Ekle'}} </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save"> {{ $t('Add-v2', { value: 'Master-Tur'}) }}</span>
        </v-tooltip>





      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.TurKodu)" item>
            <td class="text-xs-left">{{ props.item.TurKodu }}</td>
            <td class="text-xs-left">{{ props.item.TurAdi }}</td>
            <td class="text-xs-left">{{ props.item.Kategori.isim }}</td>
            <td class="text-xs-left">{{ props.item.UrunGrubu.isim }}</td>
            <td class="text-xs-left">{{ props.item.Gunduz }}</td>
            <td class="text-xs-left">{{ props.item.Gece }}</td>
            <td class="text-xs-left">{{ props.item.Kontenjan }}</td>
            <td class="text-xs-left">{{ props.item.Notlar }}</td>
            <td class="text-xs-right">
                      <v-btn
                        color="info"
                        @click="gitUpdate(props.item)"
                        icon small flat
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn  @click="" icon small flat>
                <v-icon color="warning"  @click="deleteDialogOpen(props.item)">delete</v-icon>
              </v-btn>
                    </td>
                 
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
 
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import tool from "../coper/tools";

  export default {
    data() {
      return {
        deleteDialog: false,
        deleteId:0,
        validbanka: true,
        passwordRules: [
          v => !!v || this.$t('This-space-cannot-left-blank'),
          v => (v && v.length < 5) || this.$t('Maximum-4-characters')
        ],
        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'Tur Kodu',
            
          },
          {
            text: 'Tur Adı',
            value: 'TurAdi'
          },
          {
            text: 'Ürün Grubu',
            value: 'UrunGurubuAdi'
          },
          {
            text: 'Kategori',
            value: 'KategoriAdi'
          },
          {
            text: 'Gündüz',
            value: 'Gunduz'
          },
          {
            text: 'Gece',
            value: 'Gee'
          },
          {
            text: 'Notlar',
            value: 'Notlar'
          },
          {
            text: 'İşlem',
          
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        MasterTur: {
          Id: 3,
      TurKodu: "ABC",
      TurAdi: "ABC Tur",
      Notlar: "",
      Gece: 1,
      Gunduz: 1,
      Aktif: false,
      Kategori: {
        id: "0",
        kod: null,
        isim: null,
        tip: 0,
        intField: null,
      },
      UrunGrubu: {
        id: "0",
        kod: null,
        isim: null,
        tip: 0,
        intField: null,
      },
      Kontenjan: 0,
      KayitTarihi: "2024-09-11T16:22:28"


        },
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => this.$t('Must-least-4-digits'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.MasterTurList();


    
    },
    methods: {
      deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteId = val.Id;
    },
    deleteMasterTur(id)
    {
      let params = {
        Id: this.deleteId,
      };
      tool.http_post(this, "MasterTurDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.MasterTurList();
           this.deleteDialog=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );

    },
      gitUpdate(val)
      {

       
        var url = '#/pakettur/masterpaketislem/islem?id=' +  val.Id;

window.open(url, '_self')
      },
      yeniekle() {
            var url = '#/pakettur/masterpaketislem/islem?id=0'

            window.open(url, '_self')
        },
        
        MasterTurList() {
     
      let params = {
        Ref: 0,
        TurKodu: null,
        TurAdi: null,
        Notlar: null,
        Gece: 0,
        Gunduz: 0,
        Aktif: false,
        KategoriId: 0,
        UrunGrubuId: 0,
        Kontenjan: 0,
        KayitTarihi: "2020-01-01T00:00:00",
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "MasterTurList", params).then(
        (response) => {
          if (response.body.Status == true) {
            console.log("MasterTurList response :");
            console.log(response.body);
            this.items=response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },

     
      deletemastertur: deletemastertur,
      masterturekle: masterturekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    
  }


  function Kaydet() {


    if (this.$refs.formbanka.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

     
  }
  }
  function masterturekle() {

    this.dialog = true
    this.MasterTur = {}
    this.dialog_baslik = 'Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletemastertur() {
    if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    
    }
  }

  function guncelle() {
   
  }
</script>

<style>

</style>